import { useEffect, useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import Obj2StrArr from './Obj2StrArr.js'

function MembersListNewDebitDialog(props) {
    const { setShowNewDebitDialog, checkedRows, Debits, Members, debitsFiltering, DbUpload, offlineMembersUpdate } = props;
    const [checkedDebits, setCheckedDebits] = useState([]);
    const [showFGdebits, setShowFGdebits] = useState(false);

    useEffect(() => {
        let showFGdebs = false;
        for (let m of checkedRows)
            showFGdebs = showFGdebs || !!Members[m].grupo_familiar
        setShowFGdebits(showFGdebs);
    }, [checkedRows, Members])



    const addDebits = () => {
        let uploadsArray = {},
            members = [...checkedRows],
            [memberDebits, familyGroupDebits] = debitsFiltering(checkedDebits);
        for (let m of members) {
            let fgid = !!Members[m].grupo_familiar ? ('FG-' + Members[m].grupo_familiar) : null;
            if (!!fgid && !members.includes(fgid) && !!Members[fgid])
                members.push(fgid);
        }
        for (let u of members) {
            let debs = u.startsWith('FG-') ? familyGroupDebits : memberDebits,
                prev = typeof Members[u].debitos === 'string' ? (Members[u].debitos || '').split("\n") : Members[u].debitos || [],
                post = [...new Set([...prev, ...debs])].filter(d => !!d).toSorted();

            console.log(u, debs, prev, post)

            Object.assign(uploadsArray, Obj2StrArr({ debitos: post }, `/members/${u}`) || {});
        }
        DbUpload(uploadsArray).then(r => r && offlineMembersUpdate());
        setCheckedDebits([]);
        setShowNewDebitDialog(false);
    }

    return (
        <Dialog
            id="new-debit-dialog"
            open={true}
            onClose={() => setShowNewDebitDialog(false)}
        >
            <DialogTitle>
                Nuevo Débito
            </DialogTitle>
            <DialogContent>
                <Table
                    stickyHeader
                    size="small"
                    sx={{
                        '& td': { py: 1, border: 'none' },
                        '& th': { fontWeight: 'bold' },
                        '& td:first-of-type, & th:first-of-type': { px: 1, textAlign: 'center', minWidth: '5ch', fontWeight: 'normal' },
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontSize: '.8em' }}>{checkedDebits.length ? `(${checkedDebits.length})` : ''}</TableCell>
                            <TableCell>Concepto</TableCell>
                            <TableCell>Monto</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(Debits)
                            .filter(d => !!Debits[d] && !!Debits[d].timestamp)
                            .filter(d => !!showFGdebits || !Debits[d].periodicidad.toLowerCase().includes('familiar'))
                            .map(deb => (
                                <TableRow
                                    key={`NewDebitsDialog-${deb}`}
                                    onClick={() => {
                                        setCheckedDebits(checkedDebits.includes(deb) ? checkedDebits.filter(d => d !== deb) : [...checkedDebits, deb])
                                    }}
                                >
                                    <TableCell>{checkedDebits.includes(deb) ? '🗹' : '☐'}</TableCell>
                                    <TableCell>{Debits[deb].nombre}</TableCell>
                                    <TableCell>${Debits[deb].importe}</TableCell>
                                    <TableCell>{Debits[deb].periodicidad.replaceAll('/', '/ ')}</TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowNewDebitDialog(false)} color="error">Cancelar</Button>
                <Button onClick={addDebits} color="success">Grabar</Button>
            </DialogActions>
        </Dialog>

    )
}

export default MembersListNewDebitDialog;